import React from "react";
import {
  DownArrow,
  RedArrowUpIcon,
  smallArrowDownIcon,
} from "../../../../assets/images";

type AppProps = {
  title: string;
  count: string;
  type: string;
  handleAccordianChange: (type: string) => void;
  isAccordianOpen: any;
};

const BillOfMaterialAccordian = ({
  title,
  count,
  type,
  handleAccordianChange,
  isAccordianOpen,
}: AppProps) => {
  return (
    <div className={`bomAccordian pointer`} onClick={() => handleAccordianChange(type)}>
      <div className="d-flex">
        <div className="count">{count}</div>

        <div className="accordianTitle">{title}</div>
      </div>

      <div className="pointer">
        {isAccordianOpen[type] ? (
          <img
            src={RedArrowUpIcon}
            onClick={() => handleAccordianChange(type)}
            alt="up"
          />
        ) : (
          <img
            src={smallArrowDownIcon}
            onClick={() => handleAccordianChange(type)}
            alt="down"
          />
        )}
      </div>
    </div>
  );
};

export default BillOfMaterialAccordian;
